// extracted by css-extract-rspack-plugin
export default {"searchResultsList":"SearchResults-module__searchResultsList___Id7rA","resultsContainer":"SearchResults-module__resultsContainer___K70uj"};